<template>

  <div>

    <xolas-table
      ref="progress-table"
      table-ref="progesstable"

      :title="permitLabel + ' Report'"
      icon="fa fa-file"

      url="/view/actions/prg"
      :fields="fields"

      sort-field="siteName"
      layer-component="progress"
      :layer-args="{ id: 'id' }">
  </xolas-table>

</div>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

export default {
  mixins: [DateMixins, NumberMixins],

  data () {
    return {
      permitLabel: settings.permitLabel,
      // minWidth hints mirror the pre-migration vuetable-2 render, measured at
      // 1504px viewport (.context/xol-234-baselines/metrics.json,
      // progress-report[0]) — el-table distributes un-sized columns equally,
      // which does not match the legacy content-based auto layout.
      // 'remarks' baseline width is 0 (hidden-lg-and-down at 1504px, matching
      // the legacy CSS-hidden state) — no minWidth added, class kept as-is.
      fields: [
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          minWidth: 287
        },
        {
          name: 'siteId',
          title: 'Site ID',
          sortField: 'siteId',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 250
        },
        {
          name: 'siteName',
          title: 'Site Name',
          sortField: 'siteName',
          minWidth: 453
        },
        {
          name: 'submitted_at',
          title: 'Submitted',
          sortField: 'submitted_at',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate,
          minWidth: 152
        },
        {
          name: 'completed_at',
          title: 'Completed',
          sortField: 'completed_at',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate,
          minWidth: 161
        },
        {
          name: 'remarks',
          title: 'Remarks',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down'
        }
      ]
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
